import { createFileRoute } from "@tanstack/react-router";
import { RoutedInformation } from "@/components/RoutedInformation";

export const Route = createFileRoute("/disclaimer")({
  component: () => <RoutedInformation section="disclaimer" />,
});
